import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Inject,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  AfterViewInit,
} from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { ConfirmDialogComponent } from 'src/app/shared-layout/Components/confirm-dialog/confirm-dialog.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-device-name',
  templateUrl: './device-name.component.html',
  styleUrls: ['./device-name.component.scss'],
})
export class DeviceNameComponent implements OnInit, AfterViewInit {
  /**
   * all necessary input get values from parent
   */
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();
  readonly LANG_CONST = LANG_CONST;
  CONSTANTS = CONSTANTS;
  deviceNameForm!: FormGroup;
  errorMessage: string = '';
  @Input() formGroupName!: string;
  existingDeviceType: string = '';
  focusOnPreviousModal = false;
  orignalFormData: string | undefined;
  @ViewChild('deviceName') deviceName: ElementRef | undefined;

  get formInstance() {
    return this.deviceNameForm?.controls;
  }

  constructor(
    private rootFormGroup: FormGroupDirective,
    private helperService: HelperService,
    @Inject(MAT_DIALOG_DATA) private modalData: any,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService
  ) {}

  /**
   * @description this is onInit life cycle method
   */
  ngOnInit(): void {
    this.deviceNameForm = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;
    // in case form state create mode
    if (!this.modalData.isEditable)
      this.orignalFormData = JSON.stringify(this.deviceNameForm.value);
  }

  /**
   * @description close modal dialogue with help of material service
   * @returns void
   */
  closeDialog(): void {
    if (this.orignalFormData === JSON.stringify(this.deviceNameForm.value)) {
      this.dialogRef?.close();
      return;
    }
    const dialogInstance = this.helperService.openModalDialog(
      ConfirmDialogComponent,
      {
        title: this.translate.instant('TITLE'),
        headingText: this.translate.instant('HEADING_TEXT'),
        bodyText: this.translate.instant('BODY_TEXT'),
        footerText: this.translate.instant('FOOTER_TEXT'),
      },
      CONSTANTS.FIXED_SCREEN_MODAL
    );
    dialogInstance.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.dialogRef?.close();
      }
    });
  }

  /**
   * @description navigate to next screen
   * @returns void
   */
  navigateToNextStep(): void {
    if (this.deviceNameForm.valid) {
      this.stepperChange.emit((this.stepper = 2));
    }
  }
  ngAfterViewInit() {
    if (!this.focusOnPreviousModal) {
      this.focusOnPreviousModal = true;
      this.cdr.detectChanges();
      this.deviceName?.nativeElement.focus();
    }
  }
}
